import "./MissionVision.scss";
import { Parallax } from "react-scroll-parallax";
import { images } from "../../../utils/images";
import { baseUrl } from "../../../utils/apiData";
import { motion } from "framer-motion";

const MissionVision = ({ title, dataList }) => {
  return (
    <section className="mission_vision p_t" id="accodion">
      <img
        src={images.densePattern}
        alt="Pattern"
        className="bg_pattern"
        style={{ opacity: "0.1" }}
      />
      <Parallax translateX={[-20, 20]}>
        <h1 className="gold big">{title}</h1>
      </Parallax>
      <h1 className="gold tab">{title}</h1>
      <div className="content_wrap p_t">
        {dataList?.map((data, k) => {
          return (
            <div
              className={`bi_sec p_b ${k % 2 !== 0 ? "switch" : ""}`}
              key={k}
            >
              <div className="img_wrap">
                <img src={`${baseUrl}/${data?.image}`} alt="Features" />
              </div>
              <div className="text_side">
                <h2 className="gold">
                  {data?.name &&
                    data?.name
                      ?.split("")
                      .map((char, k) => (
                        <motion.span
                          initial={{ translateX: 24, opacity: 0 }}
                          whileInView={{ translateX: 0, opacity: 1 }}
                          transition={{
                            duration: 0.4,
                            ease: "easeInOut",
                            delay: 0.02 * k,
                          }}
                          key={k}
                        >
                          {char}
                        </motion.span>
                      ))
                      .concat("")}
                </h2>
                <p className="gold">{data?.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
export default MissionVision;
